import { BESTSELLER_FILTER_TYPE_MAP } from '../../../../constants/globalTypes'

export const GA_CLICK_ACTION = {
  TABLE_GROUP: 'TABLE_GROUP',
  TABLE_SORT: 'TABLE_SORT',
  TABLE_LINK_AVAILABLE_QUANTITY: 'TABLE_LINK_AVAILABLE_QUANTITY',
  TABLE_LINK_PRICE: 'TABLE_LINK_PRICE',
  TABLE_LINK_READ_MORE: 'TABLE_LINK_READ_MORE',
  STOCK0: 'STOCK0'
}

export const GA_KEY = {
  TABLE_GROUP_DAY1: 'TABLE_GROUP_DAY1',
  TABLE_GROUP_DAY7: 'TABLE_GROUP_DAY7',
  TABLE_GROUP_DAY14: 'TABLE_GROUP_DAY14',
  TABLE_GROUP_DAY30: 'TABLE_GROUP_DAY30',
  TABLE_SORT_AMOUNT: 'TABLE_SORT_AMOUNT',
  TABLE_SORT_QUANTITY: 'TABLE_SORT_QUANTITY',
  TABLE_SORT_PAGEVIEW: 'TABLE_SORT_PAGEVIEW',
  TABLE_SORT_CONVERSION_RATE: 'TABLE_SORT_CONVERSION_RATE',
  TABLE_LINK_AVAILABLE_QUANTITY: 'TABLE_LINK_AVAILABLE_QUANTITY',
  TABLE_LINK_PRICE: 'TABLE_LINK_PRICE',
  TABLE_LINK_READ_MORE: 'TABLE_LINK_READ_MORE',
  STOCK0: 'STOCK0'
}

export const GA_KEY_MAP = {
  [GA_KEY.TABLE_GROUP_DAY1]: 'topsell_day1',
  [GA_KEY.TABLE_GROUP_DAY7]: 'topsell_day7',
  [GA_KEY.TABLE_GROUP_DAY14]: 'topsell_day14',
  [GA_KEY.TABLE_GROUP_DAY30]: 'topsell_day30',
  [GA_KEY.TABLE_SORT_AMOUNT]: 'topsell_orderamt',
  [GA_KEY.TABLE_SORT_QUANTITY]: 'topsell_ordercnt',
  [GA_KEY.TABLE_SORT_PAGEVIEW]: 'topsell_orderpv',
  [GA_KEY.TABLE_SORT_CONVERSION_RATE]: 'topsell_ordercvr',
  [GA_KEY.TABLE_LINK_AVAILABLE_QUANTITY]: 'topsell_availcnt',
  [GA_KEY.TABLE_LINK_PRICE]: 'topsell_currentprice',
  [GA_KEY.TABLE_LINK_READ_MORE]: 'topsell_moreitems',
  [GA_KEY.STOCK0]: 'topsell_list_stock0'
}

export const getI13nModel = (action = {}, customizeI13nModel = {}) => {
  const { type, payload } = action
  let key
  switch (type) {
    case GA_CLICK_ACTION.TABLE_GROUP: {
      const map = {
        1: GA_KEY.TABLE_GROUP_DAY1,
        7: GA_KEY.TABLE_GROUP_DAY7,
        14: GA_KEY.TABLE_GROUP_DAY14,
        30: GA_KEY.TABLE_GROUP_DAY30
      }
      key = map[payload]
      break
    }
    case GA_CLICK_ACTION.TABLE_SORT: {
      const map = {
        [BESTSELLER_FILTER_TYPE_MAP.AMOUNT.type]: GA_KEY.TABLE_SORT_AMOUNT,
        [BESTSELLER_FILTER_TYPE_MAP.QUANTITY.type]: GA_KEY.TABLE_SORT_QUANTITY,
        [BESTSELLER_FILTER_TYPE_MAP.PAGE_VIEW.type]: GA_KEY.TABLE_SORT_PAGEVIEW,
        [BESTSELLER_FILTER_TYPE_MAP.CONVERSION_RATE.type]: GA_KEY.TABLE_SORT_CONVERSION_RATE
      }
      key = map[payload]
      break
    }
    case GA_CLICK_ACTION.TABLE_LINK_AVAILABLE_QUANTITY:
    case GA_CLICK_ACTION.TABLE_LINK_PRICE:
    case GA_CLICK_ACTION.TABLE_LINK_READ_MORE:
    case GA_CLICK_ACTION.STOCK0:
      key = GA_KEY[type]
      break
    default:
      break
  }
  const i13nModel = {
    label: GA_KEY_MAP[key],
    ...customizeI13nModel
  }
  return i13nModel
}
